module.exports = __webpack_public_path__ + "static/media/icon+enb.4ef05e9b.svg";